import React from "react"
import {Stack, Box, Typography} from "@mui/material"
import PropTypes from "prop-types"

const ChartLegend = ({widget, value}) => {
    const data = value?.datasets

    return (
        <Stack spacing={2}>
            {data?.map((item) => (
                <Box key={item?.label} display="flex" alignItems="center" gap="4px">
                    <Box backgroundColor={item?.backgroundColor} borderRadius="50%" width="10px"
                         height="10px"></Box><Typography fontSize="14px" fontWeight={600}
                                                         lineHeight="14px">{item?.label}</Typography>
                </Box>
            ))}
        </Stack>
    )
}

ChartLegend.propTypes = {
    widget: PropTypes.object
}

export default ChartLegend
